var map = {
	"./add-oneyuan-bg.svg": "36a6",
	"./add-oneyuan-pointer.svg": "3531",
	"./add-oneyuan-sanjiao.svg": "99b1",
	"./add-oneyuan-select.svg": "dcdc",
	"./agreement-select.svg": "a3d9",
	"./alert.svg": "faed",
	"./balance_pay.svg": "55ed",
	"./baseline.svg": "b9c4",
	"./bless-jinzhu-icon.svg": "c5ab",
	"./bless-vip-icon.svg": "4dfc",
	"./blessingSong.svg": "2755",
	"./close.svg": "3496",
	"./close_sound.svg": "7571",
	"./control_icon.svg": "9819",
	"./countdown-clock.svg": "cca1",
	"./delete.svg": "e6b2",
	"./duigou.svg": "a011",
	"./footer-icon1.svg": "d196",
	"./footer-icon2.svg": "d882",
	"./footer-icon3.svg": "af85",
	"./footer-icon4.svg": "ac0c",
	"./general_order_icon.svg": "ebca",
	"./geshen.svg": "a87e",
	"./gf_select_icon.svg": "1a4a",
	"./gm-inform.svg": "35c9",
	"./gm-search.svg": "9bc2",
	"./gm-search_highlight.svg": "61d3",
	"./gm_icon.svg": "6f24",
	"./gm_vip.svg": "d9cb",
	"./gold_icon.svg": "7cad",
	"./haichang.svg": "bb7e",
	"./have-ordered.svg": "786d",
	"./index-singer-icon.svg": "067e",
	"./left.svg": "8cba",
	"./love.svg": "e0e3",
	"./maiba_icon.svg": "4f88",
	"./maikefeng.svg": "1de0",
	"./more.svg": "cda1",
	"./newGift.svg": "6bba",
	"./no-limit.svg": "752e",
	"./open_sound.svg": "1c0f",
	"./open_vip.svg": "6e29a",
	"./orderSong.svg": "90e7",
	"./order_icon.svg": "118b",
	"./order_meal.svg": "19dc",
	"./pay_not_enough.svg": "01ed",
	"./pay_not_select.svg": "220b",
	"./pay_selected.svg": "ab6d",
	"./photoBtn.svg": "f6cc",
	"./play_song.svg": "67b4",
	"./recommend.svg": "40a8",
	"./search.svg": "2fb8",
	"./sendgifts.svg": "9353",
	"./shuaxin.svg": "1eb8",
	"./square-custom.svg": "ecd9",
	"./super_vip.svg": "a8b7",
	"./top_icon.svg": "0e90",
	"./vip.svg": "dd57",
	"./vip2.svg": "45a5",
	"./vipzone-active.svg": "4b4a",
	"./vipzone-custom-active.svg": "bf79",
	"./vipzone.svg": "3d8c",
	"./voice.svg": "7c83",
	"./wuqu.svg": "0217",
	"./wx_pay.svg": "a77b",
	"./xa_checked.svg": "c21f",
	"./xa_unchecked.svg": "83e5",
	"./xianshi.svg": "9dce",
	"./yinyi.svg": "23eb",
	"./zhufu_icon.svg": "3ed7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b5d4";